import React from "react";
import styles from "./Card.module.scss";
import { Text } from "@mantine/core";

export const CardContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { disabled?: boolean }
> = ({ disabled, children, className, style, ...rest }) => (
  <div
    className={`${styles.cardContainer} ${disabled ? styles.disabled : ""} ${className ?? ""}`}
    style={style}
    {...rest}>
    {children}
  </div>
);

export const CardSeparator: React.FC<
  { disabled?: boolean } & React.HTMLAttributes<HTMLDivElement>
> = ({ disabled, className, style, ...rest }) => (
  <div
    className={`${styles.cardSeparator} ${disabled ? " " + styles.disabled : ""} ${className ?? ""}`}
    style={style}
    {...rest}
  />
);

export const NoEntries: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children }) => (
  <p className={styles.noEntries}>{children}</p>
);

export const BottomText: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children }) => (
  <p className={styles.bottomText}>{children}</p>
);

export const CardName: React.FC<any> = props => (
  <Text className={styles.cardName} {...props} />
);

export const ButtonContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => (
  <div className={`${styles.buttonContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
